/**
 * Bridges the storefront's real `hubspotutk` cookie into the sandboxed
 * Activity Lane Web Pixel (pixels/activity-pixel.js, TSE-925).
 *
 * The pixel runs in Shopify's Web Pixels sandbox and has no reliable access
 * to the storefront's real document.cookie jar. This script runs in the
 * normal theme document (real cookie access) and forwards the value through
 * Shopify's theme -> pixel custom event channel (`Shopify.analytics.publish`),
 * which the pixel receives via a literal `analytics.subscribe(...)` call.
 *
 * HubSpot's tracking script (loaded via GTM) sets `hubspotutk` asynchronously
 * after page load, so this polls for a short window instead of reading once.
 */
(function () {
  var EVENT_NAME = 'irrigreen:hutk_captured';
  var MAX_ATTEMPTS = 15;
  var INTERVAL_MS = 2000;
  var attempts = 0;

  function readHubspotUtk() {
    var match = document.cookie.match(/(?:^|; )hubspotutk=([^;]*)/);
    return match ? match[1] : null;
  }

  function publish(hutk) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(EVENT_NAME, { hutk: hutk });
      }
    } catch (e) {
      // a tracking bug must never break the storefront
    }
  }

  function tick() {
    attempts += 1;
    var hutk = readHubspotUtk();
    if (hutk) publish(hutk);
    if (attempts < MAX_ATTEMPTS) setTimeout(tick, INTERVAL_MS);
  }

  tick();
})();
